import React, {Component} from 'react';
import {connect} from 'react-redux';
import SearchActions from '../redux/SearchRedux';
import {ContentWrapper} from '../components/ContentWrapper';
import SearchDrawer from '../components/SearchDrawer';


class GlobalSearchPage extends Component {
  componentDidMount() {
    if (this.props.search.query) {
      this.props.onSearch(this.props.search.query);
    }
  }

  render() {
    const {
      search,
      onSearch,
    } = this.props;
    
    return (
      <ContentWrapper>
        <SearchDrawer
          {...search}
          onSearch={onSearch}
          hideMoreButton={true}
        />
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    search: state.search,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSearch: query => dispatch(SearchActions.searchRequest(false, query)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalSearchPage);